import script from "./WageEmployeeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageEmployeeModal.vue?vue&type=script&setup=true&lang=ts"

import "./WageEmployeeModal.vue?vue&type=style&index=0&id=9d4be656&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d4be656"]])

export default __exports__